


















import { Component, Vue, Prop } from "vue-property-decorator";
import ProjectDetails from "../Details/ProjectDetails.vue";
import PersonnelSelector from "../Selectors/PersonnelSelector.vue";
import {project} from "../../api/project/project";
@Component({
  name: "AddProject",
  components: {
    ProjectDetails,
    PersonnelSelector
  },
  data: function() {
    return {
      active: 0,
      componentname: "ProjectDetails",
      loading: true,
      project: [],
      details: []
    };
  },
  props: {
    obj: {
      default: undefined
    }
  },
  computed: {
    projectObject: {
      get: function() {
        return this.$data.project;
      },
      set: function(newVal) {
        this.$data.project.push(newVal);
      }
    }
  }
})
export default class AddProject {
  public next() {
    if (this.$data.active++ > 1) {
      this.$data.active = 0;
      if (this.details.id === undefined) {
        project.addproject(this.$store.getters.getToken, this.$data.project,this.$store.getters.getHost);
      } else {
        project.editproject(this.$store.getters.getToken, this.$data.project,this.$store.getters.getHost);
      }
    }
    this.drawPage();
  }
  public drawPage() {
    console.log(this.$data.project);
    this.$data.loading = true;
    switch (this.$data.active) {
      case 0:
        this.$data.componentname = "projectDetails";
        break;
      case 1:
        this.$data.componentname = "PersonnelSelector";
        break;
    }
  }
  public async getDetails(details) {
    this.projectObject = details;
  }
  public async getPersonnel(personnel) {
    this.projectObject = personnel;
  }
}
